import * as React from 'react'
import EditFeatureDispatcherContainer from './EditFeatureDispatcherContainer'
import {IFeatureLayerInfos, ISelectedFeature} from '../../core/interfaces/reducers'
import {connect} from 'react-redux'
import {
  ISingleCreateDispatcher,
  IEditsDispatcher,
  IGeometryEditsDispatcher,
  IPopupDispatcher
} from '../../core/interfaces/dispatchers'
import {appSingleCreateDispatcher} from '../../dispatchers/appSingleCreateDispatcher'
import {IFeatureLayerInfo} from '../../core/interfaces/models'
import {createNewFeature} from '../../core/helpers'
import OverlayLoader from '../../core/components/Loading/OverlayLoading'
import {appEditsDispatcher} from '../../dispatchers/appEditsDispatcher'
import {Feature, FeatureStatus} from '../../core/models'
import {appGeometryEditsDispatcher} from '../../dispatchers/appGeometryEditsDispatcher'
import {appPopupDispatcher} from '../../dispatchers/appPopupDispatcher'
import TableSelector from '../../core/components/Tables/TableSelector'
import {IAppStore, IAppUser} from '../../interfaces/reducers'
import appConfig from '../../reducers/appConfig'

interface OwnProps {
  layerInfos: IFeatureLayerInfos
  selectedFeature?: ISelectedFeature
  user?: IAppUser
}

interface ParentProps {}

interface DispatchProps extends ISingleCreateDispatcher, IEditsDispatcher, IGeometryEditsDispatcher, IPopupDispatcher {}

type Props = OwnProps & ParentProps & DispatchProps

interface State {
  selectedLayerInfoKey: string
}

class FeatureCreator extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props)
    const infos = this.filterInfos(props.layerInfos)
    const selectedLayerInfoKey = Object.keys(infos).length > 0 ? infos[Object.keys(infos)[0]].url : ''
    this.state = {
      selectedLayerInfoKey
    }

    this.createFeature = this.createFeature.bind(this)
    this.setFeature = this.setFeature.bind(this)
  }
  componentDidMount() {
    const infos = this.filterInfos(this.props.layerInfos)
    if (this.state.selectedLayerInfoKey) {
      this.setFeature(
        this.createFeature(infos[this.state.selectedLayerInfoKey]),
        infos[this.state.selectedLayerInfoKey]
      )
    }
  }

  createFeature(layerInfo: IFeatureLayerInfo): Feature {
    return createNewFeature(layerInfo)
  }

  setFeature(feature: Feature, layerInfo: IFeatureLayerInfo) {
    // this.props.setOriginals({[layerInfo.url]: {[feature.getId()]: feature}}, () => {
    //     let mapEditingService = getMapService().editing;
    //     mapEditingService.setForEditing({[layerInfo.url]: {[feature.getId()]: feature}});
    this.props.setSelectedFeature(feature, layerInfo.url)
    // })
  }

  protected filterInfos(layerInfos: IFeatureLayerInfos): IFeatureLayerInfos {
    const infos: IFeatureLayerInfos = {}
    for (const i in layerInfos) {
      if (!layerInfos[i].sourceDescription.readOnly) {
        if (
          this.props.user &&
          (this.props.user.isAdmin ||
            (appConfig.reg.regrelated.indexOf(layerInfos[i].sourceDescription.id) != -1 &&
              this.props.user.isRegAdmin) ||
            (appConfig.misc.miscrelated.indexOf(layerInfos[i].sourceDescription.id) != -1 &&
              this.props.user.isCadAdmin) ||
            (appConfig.oup.ouprelated.indexOf(layerInfos[i].sourceDescription.id) != -1 &&
              this.props.user.isOpuAdmin) ||
            (appConfig.und.undrelated.indexOf(layerInfos[i].sourceDescription.id) != -1 && this.props.user.isUndAdmin))
        )
          infos[i] = layerInfos[i]
      }
    }
    return infos
  }
  protected getSelector(): JSX.Element | null {
    const infos = this.filterInfos(this.props.layerInfos)
    return (
      <TableSelector
        onChange={key => {
          this.setState({...this.state, selectedLayerInfoKey: ''}, () => {
            // FeatureEditor must be mounted every time
            this.setState({...this.state, selectedLayerInfoKey: key})
            this.setFeature(this.createFeature(this.props.layerInfos[key]), this.props.layerInfos[key])
          })
        }}
        layerInfos={infos}
        visibleTables={{[this.state.selectedLayerInfoKey]: this.state.selectedLayerInfoKey}}
      />
    )
  }

  render() {
    if (
      !this.state.selectedLayerInfoKey ||
      !this.props.selectedFeature ||
      !this.props.layerInfos[this.props.selectedFeature.id] ||
      this.props.selectedFeature.feature.status == FeatureStatus.Deleted
    ) {
      return (
        <div>
          Няма обекти елементи за създаване
          {Object.keys(this.props.layerInfos).length > 1 ? this.getSelector() : null}
        </div>
      )
    }
    const layerInfo = this.props.layerInfos[this.props.selectedFeature.id]
    return (
      <div style={{height: '100%', display: 'flex', flexDirection: 'column'}}>
        {Object.keys(this.props.layerInfos).length > 1 ? this.getSelector() : null}
        {this.props.selectedFeature.loading ? (
          <div style={{position: 'relative'}}>
            <OverlayLoader show={true}></OverlayLoader>
          </div>
        ) : (
          <EditFeatureDispatcherContainer
            editAgain={f => {
              this.props.cancel()
              const feature = this.createFeature(layerInfo)
              this.setFeature(feature, layerInfo)
              return f
            }}
            feature={this.props.selectedFeature.feature}
            layerId={layerInfo.sourceDescription.id}
            hideCancel={true}
            hideDelete={true}
          />
        )}
      </div>
    )
  }
}

const mapStateToProps = (store: IAppStore) => ({
  layerInfos: store.layerInfos.featureLayerInfos,
  selectedFeature: store.data.singleCreateSelectedFeature,
  user: store.userInfo.user
})

export default connect<OwnProps, DispatchProps, ParentProps>(mapStateToProps, {
  ...appSingleCreateDispatcher,
  ...appEditsDispatcher,
  ...appGeometryEditsDispatcher,
  ...appPopupDispatcher
})(FeatureCreator)
